import Home from './home';
import Menu from './menu';
import MenuItemModal from './menu-item-modal';
import Rewards from './rewards';
import Components from './components';

export default {
  Home,
  Menu,
  MenuItemModal,
  Rewards,
  Components,
};
